import { FunctionComponent, ReactNode } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button/Button";
import { ButtonColor } from "@/components/Button/types";

interface CompanyEnrichFormActionsProps {
	children?: ReactNode;
	onCancel?: () => void;
	onPreview: () => void;
	previewLoading: boolean;
	onSubmit: () => void;
	submitLoading: boolean;
	submitTitle: string;
}

export const CompanyEnrichFormActions: FunctionComponent<CompanyEnrichFormActionsProps> = ({
	children,
	onCancel,
	onPreview,
	previewLoading,
	onSubmit,
	submitLoading,
	submitTitle,
}) => {
	const { t } = useTranslation();

	return (
		<div className="p-4 rounded-xl border border-border-light bg-brand-white">
			{children}

			<div className="flex gap-4 w-full justify-end">
				{onCancel && (
					<div className="flex max-w-[100px] w-full">
						<Button
							className="w-full"
							color={ButtonColor.ACTION_SECONDARY}
							title={t("basics.cancel")}
							onClick={onCancel}
						/>
					</div>
				)}
				<div className="flex w-fit">
					<Button
						className="w-full"
						color={ButtonColor.ACTION_SECONDARY}
						isLoading={previewLoading}
						title={t("basics.preview")}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							onPreview();
						}}
					/>
				</div>
				<div className="flex max-w-[150px] w-full">
					<Button
						className="w-full"
						isLoading={submitLoading}
						title={submitTitle}
						onClick={onSubmit}
					/>
				</div>
			</div>
		</div>
	);
};
